import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';

const recommend = i18n.message('smarthelp/contactOption.recommend');
const chat = i18n.message('smarthelp/contactOption.chat');
const tooltip = i18n.message('smarthelp/contactOption.recommended.tooltip');

class ContactOption extends Component {
  renderRecommended() {
    if (!this.props.recommended) {
      return null;
    }
    return (
      <div className="recommended">
        <p className="icon-recommended" data-tip={tooltip}>{recommend}</p>
        <ReactTooltip className="tooltip_passcode" multiline place="bottom" float="solid" />
      </div>
    );
  }
  renderTooltip() {
    if (this.props.toolTip) {
      return (<div className="chat-tip">
        <a className="tooltip-chat" role="link" data-tip={chat.tooltipContent}>{chat.toolTip}</a>
        <ReactTooltip className="tooltip_passcode" multiline place="bottom" float="solid" />
      </div>);
    }
    return null;
  }

  renderMessage() {
    return this.props.message ? (<div className={this.props.supportMessageCSS}>
      {Page.getHTMLElement({ message: this.props.message, useHTML: true })}
    </div>) : null;
  }
  render() {
    let link = <button onClick={this.props.clickAction} role="link" className={this.props.contactLinkCSS} aria-label={`${this.props.text} link`}>{this.props.text}</button>;
    if (this.props.link) {
      link = (<a
        onClick={(e) => { e.preventDefault(); return this.props.clickAction(); }}
        className={this.props.contactLinkCSS}
        href={this.props.link} target={this.props.sameTab ? '' : '_blank'}
        aria-label={`${this.props.text} link`}
      >{this.props.text}</a>);
    }
    return (

      <div className="contact-panel" id={this.props.id} style={Page.isTopicTreeDisabled() ? { float: 'none' } : {}}>
        <button className={this.props.iconClass} onClick={this.props.clickAction} aria-label={`${this.props.text} icon`} />
        <div className="channel-content">
          {link}
          {this.renderMessage()}
          {this.renderTooltip()}
          {this.renderRecommended()}
        </div>
      </div>
    );
  }
}
ContactOption.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  contactLinkCSS: PropTypes.string.isRequired,
  clickAction: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  supportMessageCSS: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
  toolTip: PropTypes.bool,
  link: PropTypes.string,
  sameTab: PropTypes.bool,
};

ContactOption.defaultProps = {
  recommended: false,
  toolTip: false,
  link: undefined,
  sameTab: false,
};

export default ContactOption;
